function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_613",
  "data-name": "Group 613",
  transform: "translate(-17 -532)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_517",
  "data-name": "Group 517",
  transform: "translate(16.833 532)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_34",
  "data-name": "Ellipse 34",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(0.167 0)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_612",
  "data-name": "Group 612",
  transform: "translate(-63.55 453.961)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_608",
  "data-name": "Path 608",
  d: "M99.726,86.733a1.941,1.941,0,0,0-1.37-1.37,46.311,46.311,0,0,0-6.056-.324,46.311,46.311,0,0,0-6.056.324,1.941,1.941,0,0,0-1.37,1.37,21.653,21.653,0,0,0,0,7.462,1.941,1.941,0,0,0,1.37,1.37,46.313,46.313,0,0,0,6.056.324,46.313,46.313,0,0,0,6.056-.324,1.941,1.941,0,0,0,1.37-1.37,21.654,21.654,0,0,0,0-7.462Z",
  fill: "red"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_609",
  "data-name": "Path 609",
  d: "M133.144,113.986l4.027-2.325-4.027-2.325Z",
  transform: "translate(-42.394 -21.197)",
  fill: "#fff"
})));

var SvgIconBtnYoutube = function SvgIconBtnYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBtnYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconBtnYoutube.79520d9a.svg";
export { ForwardRef as ReactComponent };